module.exports = __webpack_public_path__ + "img/what-to-expect-hero-desktop.b6636e82.png";